import { render } from "./wInput.vue?vue&type=template&id=2694c59a&ts=true"
import script from "./wInput.vue?vue&type=script&lang=ts"
export * from "./wInput.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__